module.exports = __webpack_public_path__ + "static/media/apple.7caa79ea.svg";